import getSteps from '../storage/stepper/getSteps';

const actions = {
  setSteps: 'SET_STEPS',
}

const setSteps = (steps) => ({
  type: actions.setSteps,
  steps: steps,
});

const startSetSteps = () => {
  return (dispatch) => {
    return getSteps()
      .then((steps) => {
        dispatch(setSteps(steps ?? []));
      });
  };
};


export {
  actions,
  startSetSteps as setSteps,
};
